import { render, staticRenderFns } from "./AreaSetting.vue?vue&type=template&id=ca4a65e0&scoped=true"
import script from "./AreaSetting.vue?vue&type=script&lang=js"
export * from "./AreaSetting.vue?vue&type=script&lang=js"
import style0 from "./AreaSetting.vue?vue&type=style&index=0&id=ca4a65e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a65e0",
  null
  
)

export default component.exports